<template>
  <modal :show.sync="modal_cart">
    <h4 slot="header" class="text-primary m-0">
      {{ $t("app.modules.modal_car_item_add.title") }}
    </h4>
    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitAddToCart)">
        <div class="row" v-for="(item) in detallPedidos" :key="item.idDetallePedido">
          <card class="box-card">
          <div class="col-md-12 col-sm-12">
           <fg-input
              disabled
              type="text"
              :label="$t('app.modules.complaints.headers.product_description')"
              v-model="item.descripcionProducto"
            >
            </fg-input>
          </div>
          <div class="col-md-12 col-sm-12">
            <span class="demonstration">{{
                $t("app.modules.modal_car_item_add.headers.quantity")}}</span>
              <div>
            <el-input-number size="medium" v-model="item.cantidad" controls-position="right" :min="1" ></el-input-number> {{ item.unidadMedida}}
              </div>
          </div>
          <div class="col-md-12 col-sm-12">
            <ValidationProvider
              :name="'requiredDatetime-' +item.idDetallePedido"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <span class="demonstration">{{
                $t("app.modules.modal_car_item_add.headers.delivery_date")
              }}</span>
              <el-date-picker
                :hasSuccess="passed"
                :picker-options="pickerOptions"
                v-model="item.fechaEntrega"
                type="date"
                :placeholder="
                  $t('app.modules.modal_car_item_add.headers.delivery_date')
                "
              >
              </el-date-picker>
              <div
                v-if="failed"
                class="text-danger invalid-feedback"
                style="display: block;"
              >
                {{ required_text }}
              </div>
            </ValidationProvider>
          </div>
          </card>
        </div>
      <div
          slot="footer"

          class="text-right"
        >
        <n-button class="pull-left" @click.native="cancelAdd" >{{
          $t("app.buttons.cancel")
        }}</n-button>
        <n-button native-type="submit" type="primary">{{
           $t("app.modules.modal_car_item_add.headers.add")
        }}</n-button>
      </div>
    </form>
    </ValidationObserver>
  </modal>
</template>

<script>
import { integer } from 'vee-validate/dist/rules'

export default {
  components: {
  },
  data(){
    return{
      detallPedidos: [],
      productosValidos: [],
      required_text: this.$t("app.general.required"),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      modal_cart: false,
      idPedidoCliente: 0
    }
  },
  async mounted(){
    EventBus.$on("show-add.all-item-cart", async idPedidoCliente => {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.idPedidoCliente = idPedidoCliente
      await this.getDetPedidoCar();
      await this.getProductsCliente();
      this.modal_cart = true;
      this.$swal.close();
    });
  },
  methods:{
      async getProductsCliente() {

        var payload = {
            clienteIdSAP: this.$store.state.user.idClienteSAP,
            claveIdioma: this.$store.state.lang,
            usuario: this.$store.state.user.idUsuario
        };
        await this.$http
          .post(route("Productos/getProductosByClienteActivos"), payload)
          .then(
            async response => {
              if (response.body.code === 200) {
                this.productosValidos = response.body.productos;
              } else {
                this.notifyMessage("danger", this.$t("app.promps.error"));
              }
            },
            error => {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          )
          .finally(() => {});

      },
    async getDetPedidoCar() {
      var paramDetall = {
        Id: this.idPedidoCliente,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0
      };
      this.detallPedidos = new Array();
      await this.$http.post(route("Pedidos/getPedidoDetalleWeb"), paramDetall).then(
        response => {
          if (response.body.code === 200) {
            for(var i=0; i < response.body.detalles.length; i++ ){
              var itemDeta = response.body.detalles[i];
              console.log(itemDeta);
              this.detallPedidos.push(
                new Object({
                  idDetallePedido: itemDeta.idDetallePedido,
                  descripcionProducto: itemDeta.descripcionProducto,
                  cantidad: itemDeta.cantidad,
                  idProductoCliente: itemDeta.idProductoCliente,
                  unidadMedida: itemDeta.unidadMedida
                })
              );
            }
            console.log(this.detallPedidos);
          } else {
           this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        },
        error => {
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      );
    },
    cancelAdd(){
      this.modal_cart = false;
    },
    async submitAddToCart(){
      var addedAll = true;
      this.detallPedidos.forEach(i => {
          var dato = this.productosValidos.find(element => element.idProductoCliente == i.idProductoCliente);
          if(dato != null) {
            EventBus.$emit("add-to-cart", i);
          }
          else{
            addedAll = false;
          }
        });
      if(!addedAll){
        this.notifyMessage("danger", this.$t("app.modules.modal_car_item_add.messages.not_added"));
      }
      this.modal_cart = false;
    },
  }
}
</script>
